//token请求头
export const AUTH_TOKEN_HEADER = "VersionConsoleToken";
//斜杠分隔符
export const DELIMITER_SLASH = "/";
